var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29432 9.68189C9.89953 9.07669 9.89953 8.09547 9.29432 7.49026C8.68912 6.88506 7.70791 6.88506 7.10271 7.49026C6.4975 8.09547 6.4975 9.07669 7.10271 9.68189C7.70791 10.2871 8.68912 10.2871 9.29432 9.68189Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7769 4.32438H12.8477C13.7023 4.32438 14.3974 5.01941 14.3974 5.87408V12.073C14.3974 12.9277 13.7024 13.6227 12.8477 13.6227H3.54972C2.69503 13.6227 2 12.9273 2 12.0726L2.00416 5.87601C2.0049 5.02321 2.69881 4.32857 3.55122 4.32705L4.62043 4.32514L5.39493 2.77466H11.0017L11.7769 4.32438ZM5.09904 8.58609C5.09904 10.2951 6.48947 11.6855 8.19849 11.6855C9.9075 11.6855 11.2979 10.2951 11.2979 8.58609C11.2979 6.87707 9.9075 5.48664 8.19849 5.48664C6.48947 5.48664 5.09904 6.87707 5.09904 8.58609Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.60dee4c6e947637a3a8ca97c5739bc74.svg";
export { ForwardRef as ReactComponent };